(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    if (window.__noxrevCartDrawerReady) {
      return;
    }

    window.__noxrevCartDrawerReady = true;

    const HEADER_OVERLAY_EVENT = 'noxrev:header-overlay-open';
    const KLAVIYO_FORM_ID = 'X8pvLK';

    let drawerController = null;
    let drawerRequestSequence = 0;
    let lastFocusedElement = null;

    const rootPath = () => window.Shopify?.routes?.root || '/';
    const getDrawer = () => document.querySelector('[data-cart-drawer]');
    const getPanel = () => getDrawer()?.querySelector('[data-cart-drawer-panel]');

    /*
     * NOXREV / Klaviyo
     * Prevent the 10% welcome popup from covering the cart drawer.
     */
    const suppressKlaviyoForms = () => {
      document.body.classList.add('noxrev-cart-open');

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['closeForm', KLAVIYO_FORM_ID]);
    };

    const restoreKlaviyoForms = () => {
      document.body.classList.remove('noxrev-cart-open');
    };

    const updateHeaderCartCount = (itemCount) => {
      document.querySelectorAll('.header__cart-count').forEach((count) => {
        count.textContent = String(itemCount);
      });
    };

    const publishCartUpdate = (cart) => {
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    };

    const setDrawerBusy = (isBusy) => {
      const drawer = getDrawer();

      if (!drawer) return;

      drawer.classList.toggle('is-updating', isBusy);
      drawer.setAttribute('aria-busy', isBusy ? 'true' : 'false');

      drawer
        .querySelectorAll(
          '[data-cart-drawer-change], [data-cart-drawer-remove], [data-cart-drawer-checkout]'
        )
        .forEach((control) => {
          control.toggleAttribute('disabled', isBusy);
        });
    };

    const showDrawerError = (message) => {
      const error = getDrawer()?.querySelector('[data-cart-drawer-error]');

      if (!error) return;

      error.textContent = message;
      error.hidden = false;
    };

    const clearDrawerError = () => {
      const error = getDrawer()?.querySelector('[data-cart-drawer-error]');

      if (!error) return;

      error.textContent = '';
      error.hidden = true;
    };

    const replaceDrawer = (html) => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextDrawer = parsed.querySelector('[data-cart-drawer]');
      const currentDrawer = getDrawer();

      if (!nextDrawer || !currentDrawer) {
        return false;
      }

      const wasOpen =
        currentDrawer.getAttribute('aria-hidden') === 'false';

      currentDrawer.replaceWith(nextDrawer);

      if (wasOpen) {
        nextDrawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-open');

        /*
         * The drawer HTML can be replaced after quantity/remove actions,
         * so make sure Klaviyo remains suppressed.
         */
        suppressKlaviyoForms();
      }

      return true;
    };

    const openDrawer = () => {
      const drawer = getDrawer();
      const panel = getPanel();

      if (!drawer || !panel) return;

      document.dispatchEvent(
        new CustomEvent(HEADER_OVERLAY_EVENT, {
          detail: { source: 'cart' },
        })
      );

      lastFocusedElement = document.activeElement;

      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');

      /*
       * Close/suppress the NOXREV 10% Klaviyo popup.
       */
      suppressKlaviyoForms();

      window.requestAnimationFrame(() => {
        panel.focus({ preventScroll: true });
      });
    };

    const closeDrawer = () => {
      const drawer = getDrawer();

      if (!drawer) return;

      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');

      /*
       * Allow Klaviyo to return to its normal targeting behaviour.
       * We do NOT force the popup to reopen.
       */
      restoreKlaviyoForms();

      if (lastFocusedElement?.isConnected) {
        lastFocusedElement.focus({ preventScroll: true });
      }
    };

    const getSectionId = () =>
      getDrawer()?.dataset.sectionId || 'cart-drawer';

    const requestCartChange = async ({ line, quantity }) => {
      const requestId = ++drawerRequestSequence;

      if (drawerController) {
        drawerController.abort();
      }

      drawerController = new AbortController();

      clearDrawerError();
      setDrawerBusy(true);

      try {
        const response = await fetch(`${rootPath()}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            line: Number(line),
            quantity: Math.max(0, Number(quantity)),
            sections: [getSectionId()],
            sections_url: window.location.pathname,
          }),
          signal: drawerController.signal,
        });

        const cart = await response.json();

        if (!response.ok) {
          throw new Error(
            cart.description ||
              cart.message ||
              'Unable to update cart.'
          );
        }

        if (requestId !== drawerRequestSequence) return;

        const sectionHtml = cart.sections?.[getSectionId()];

        if (!sectionHtml || !replaceDrawer(sectionHtml)) {
          throw new Error('Unable to refresh cart drawer.');
        }

        updateHeaderCartCount(cart.item_count || 0);
        publishCartUpdate(cart);
      } catch (error) {
        if (error.name === 'AbortError') return;

        if (requestId === drawerRequestSequence) {
          showDrawerError(
            error.message ||
              'Unable to update cart. Please try again.'
          );
        }
      } finally {
        if (requestId === drawerRequestSequence) {
          drawerController = null;
          setDrawerBusy(false);
        }
      }
    };

    const refreshDrawer = async () => {
      const url = new URL(window.location.href);

      url.searchParams.set(
        'section_id',
        getSectionId()
      );

      const response = await fetch(url.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error('Unable to refresh cart drawer.');
      }

      return replaceDrawer(await response.text());
    };

    const handleProductAdd = async (form, submitter) => {
      if (form.dataset.cartAddPending === 'true') return;
      form.dataset.cartAddPending = 'true';

      const submitButton = submitter || form.querySelector('.main-product__submit, [type="submit"]');
      const originalText = submitButton?.textContent;
      const originalDisabled = submitButton?.disabled;
      const purchaseButtons = Array.from(form.querySelectorAll('[type="submit"]')).map(button => ({button, disabled:button.disabled}));
      purchaseButtons.forEach(({button}) => { button.disabled = true; });

      const shouldSwapSubmitText =
        !submitButton?.hasAttribute(
          'data-cart-compact-submit'
        );

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');

        if (shouldSwapSubmitText) {
          submitButton.textContent = 'Adding...';
        }
      }

      try {
        const formData = new FormData(form);

        const response = await fetch(
          `${rootPath()}cart/add.js`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: formData,
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
              result.message ||
              'Unable to add item to cart.'
          );
        }

        const cartResponse = await fetch(
          `${rootPath()}cart.js`,
          {
            headers: {
              Accept: 'application/json',
            },
          }
        );

        const cart = await cartResponse.json();

        updateHeaderCartCount(cart.item_count || 0);
        publishCartUpdate(cart);

        const responseBehavior = getDrawer()?.dataset.addToCartResponse || 'open_drawer';

        if (responseBehavior === 'navigate_cart') {
          window.location.assign(getDrawer()?.dataset.cartUrl || `${rootPath()}cart`);
          return;
        }

        await refreshDrawer();

        if (responseBehavior === 'open_drawer') {
          openDrawer();
        }
      } catch (error) {
        showDrawerError(
          error.message ||
            'Unable to add item to cart. Please try again.'
        );

        openDrawer();
      } finally {
        delete form.dataset.cartAddPending;
        purchaseButtons.forEach(({button, disabled}) => { button.disabled = disabled; });

        if (submitButton) {
          submitButton.disabled = originalDisabled;
          submitButton.classList.remove('is-loading');

          if (shouldSwapSubmitText) {
            submitButton.textContent = originalText;
          }
        }
      }
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest(
        'form[action*="/cart/add"]'
      );

      if (!form || !form.querySelector('[name="id"]')) {
        return;
      }

      const submitter = event.submitter;
      if (form.dataset.cartAddPending === 'true') { event.preventDefault(); return; }
      if (
        submitter?.matches('.main-product__buy-now') &&
        submitter.name === 'return_to' &&
        submitter.value === '/checkout'
      ) {
        return;
      }

      event.preventDefault();
      handleProductAdd(form, submitter);
    });

    document.addEventListener('click', (event) => {
      const headerCartTrigger =
        event.target.closest('.header__cart');

      const closeTrigger =
        event.target.closest(
          '[data-cart-drawer-close]'
        );

      const removeTrigger =
        event.target.closest(
          '[data-cart-drawer-remove]'
        );

      const changeTrigger =
        event.target.closest(
          '[data-cart-drawer-change]'
        );

      if (headerCartTrigger) {
        event.preventDefault();
        openDrawer();
        return;
      }

      if (closeTrigger) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (removeTrigger) {
        event.preventDefault();

        requestCartChange({
          line: removeTrigger.dataset.line,
          quantity: 0,
        });

        return;
      }

      if (changeTrigger) {
        event.preventDefault();

        requestCartChange({
          line: changeTrigger.dataset.line,
          quantity: changeTrigger.dataset.quantity,
        });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        getDrawer()?.getAttribute('aria-hidden') ===
          'false'
      ) {
        closeDrawer();
      }
    });

    document.addEventListener(
      HEADER_OVERLAY_EVENT,
      (event) => {
        if (
          event.detail?.source !== 'cart' &&
          getDrawer()?.getAttribute(
            'aria-hidden'
          ) === 'false'
        ) {
          closeDrawer();
        }
      }
    );

    const eventTargetsCartDrawer = (target) =>
      target?.matches?.('[data-cart-drawer]') ||
      Boolean(target?.querySelector?.('[data-cart-drawer]'));

    document.addEventListener('shopify:section:select', (event) => {
      if (eventTargetsCartDrawer(event.target)) openDrawer();
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (eventTargetsCartDrawer(event.target)) closeDrawer();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (!eventTargetsCartDrawer(event.target)) return;
      drawerRequestSequence += 1;
      drawerController?.abort();
      drawerController = null;
      closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    document.addEventListener('shopify:block:select',event=>{
      const item=event.target.closest?.('[data-faq-item]');
      if(!item)return;
      item.hidden=false;const group=item.closest('[data-faq-group]');if(group)group.hidden=false;
      item.querySelector('[data-faq-toggle]')?.setAttribute('aria-expanded','true');const answer=item.querySelector('[data-faq-answer]');if(answer)answer.hidden=false;
      item.scrollIntoView({block:'nearest'});
    });

    const initializeFaq = (root) => {
      if (!root || instances.has(root)) return;
      const controller = new AbortController();
      const search = root.querySelector('[data-faq-search]');
      const noResults = root.querySelector('[data-faq-no-results]');

      root.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-faq-toggle]');
        if (!toggle || !root.contains(toggle)) return;

        const item = toggle.closest('[data-faq-item]');
        const group = toggle.closest('[data-faq-group]');
        const answer = item?.querySelector('[data-faq-answer]');
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (root.dataset.allowMultiple !== 'true') {
          group?.querySelectorAll('[data-faq-toggle][aria-expanded="true"]').forEach((openToggle) => {
            if (openToggle === toggle) return;
            openToggle.setAttribute('aria-expanded', 'false');
            const openAnswer = openToggle.closest('[data-faq-item]')?.querySelector('[data-faq-answer]');
            if (openAnswer) openAnswer.hidden = true;
          });
        }

        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (answer) answer.hidden = isOpen;
      }, { signal: controller.signal });

      search?.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        let visibleItems = 0;

        root.querySelectorAll('[data-faq-item]').forEach((item) => {
          const matches = !query || item.dataset.faqText.includes(query);
          item.hidden = !matches;

          if (matches) visibleItems += 1;
        });

        root.querySelectorAll('[data-faq-group]').forEach((group) => {
          const hasVisibleItem = Array.from(group.querySelectorAll('[data-faq-item]')).some((item) => !item.hidden);
          group.hidden = !hasVisibleItem;
        });

        if (noResults) {
          noResults.hidden = visibleItems > 0;
        }
      }, { signal: controller.signal });

      instances.set(root, {
        destroy: () => {
          controller.abort();
          instances.delete(root);
        },
      });
    };

    const forEachFaq = (scope, callback) => {
      if (scope.matches?.('[data-faq-page]')) callback(scope);
      scope.querySelectorAll?.('[data-faq-page]').forEach(callback);
    };

    const initializeFaqs = (scope = document) => forEachFaq(scope, initializeFaq);
    const unloadFaqs = (scope) => forEachFaq(scope, (root) => instances.get(root)?.destroy());

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeFaqs(), { once: true });
    } else {
      initializeFaqs();
    }
    document.addEventListener('shopify:section:load', (event) => initializeFaqs(event.target));
    document.addEventListener('shopify:section:unload', (event) => unloadFaqs(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const toggle = event.target.closest?.('[data-faq-toggle]') || event.target.querySelector?.('[data-faq-toggle]');
      const root = toggle?.closest('[data-faq-page]');
      if (!toggle || !root) return;

      if (root.dataset.allowMultiple !== 'true') {
        toggle.closest('[data-faq-group]')?.querySelectorAll('[data-faq-toggle][aria-expanded="true"]').forEach((openToggle) => {
          if (openToggle === toggle) return;
          openToggle.setAttribute('aria-expanded', 'false');
          const openAnswer = openToggle.closest('[data-faq-item]')?.querySelector('[data-faq-answer]');
          if (openAnswer) openAnswer.hidden = true;
        });
      }

      toggle.setAttribute('aria-expanded', 'true');
      const answer = toggle.closest('[data-faq-item]')?.querySelector('[data-faq-answer]');
      if (answer) answer.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    if (window.__noxrevHeaderReady) {
      return;
    }

    window.__noxrevHeaderReady = true;

    const HEADER_OVERLAY_EVENT = 'noxrev:header-overlay-open';
    const mobileSearchMedia = window.matchMedia('(max-width: 989px)');
    const searchControllers = new Set();
    const shell = document.querySelector('[data-site-header-shell]');

    const updateScrolledState = () => {
      const isScrolled = window.scrollY > 20;

      document.body.classList.toggle('is-scrolled', isScrolled);

      if (shell) {
        shell.classList.toggle('is-scrolled', isScrolled);
      }
    };

    updateScrolledState();
    window.addEventListener('scroll', updateScrolledState, { passive: true });
    const closeMobileMenu = (mobileMenu) => {
      if (!mobileMenu) {
        return;
      }

      if (!mobileMenu.open || mobileMenu.classList.contains('is-closing')) {
        return;
      }

      mobileMenu.classList.add('is-closing');
      document.body.classList.remove('mobile-menu-open');

      window.setTimeout(() => {
        mobileMenu.open = false;
        mobileMenu.classList.remove('is-closing');
      }, 280);
    };

    const syncMobileMenuState = (mobileMenu) => {
      if (!mobileMenu) {
        return;
      }

      if (mobileMenu.open && !mobileMenu.classList.contains('is-closing')) {
        document.body.classList.add('mobile-menu-open');
        document.dispatchEvent(new CustomEvent(HEADER_OVERLAY_EVENT, { detail: { source: 'menu' } }));
      } else if (!mobileMenu.open) {
        document.body.classList.remove('mobile-menu-open');
      }
    };

    const bindMobileMenu = (mobileMenu) => {
      if (!mobileMenu || mobileMenu.dataset.headerMenuInitialized === 'true') {
        return;
      }

      mobileMenu.dataset.headerMenuInitialized = 'true';
      mobileMenu.addEventListener('toggle', () => syncMobileMenuState(mobileMenu));
    };

    const getFocusableElements = (panel) =>
      Array.from(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null);

    const bindHeaderSearch = (header) => {
      if (!header || header.dataset.headerSearchInitialized === 'true') {
        return;
      }

      const trigger = header.querySelector('[data-header-search-open]');
      const overlay = header.querySelector('[data-header-search-overlay]');
      const panel = overlay?.querySelector('[data-header-search-panel]');
      const searchRoot = overlay?.querySelector('[data-catalog-search]');
      const input = searchRoot?.querySelector('[data-catalog-search-input]');

      if (!trigger || !overlay || !panel || !searchRoot || !input) {
        return;
      }

      header.dataset.headerSearchInitialized = 'true';
      window.NoxrevCatalogSearch?.mount(searchRoot);

      const controller = {
        header,
        trigger,
        overlay,
        panel,
        input,
        isOpen: () => overlay.getAttribute('aria-hidden') === 'false',
        syncPosition() {
          if (!controller.isOpen()) {
            return;
          }

          const isMobile = mobileSearchMedia.matches;
          panel.toggleAttribute('aria-modal', isMobile);
          if (isMobile) {
            panel.setAttribute('aria-modal', 'true');
            overlay.style.removeProperty('--catalog-search-header-top');
          } else {
            panel.removeAttribute('aria-modal');
            const headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
            overlay.style.setProperty('--catalog-search-header-top', `${headerBottom}px`);
          }
          document.body.classList.toggle('catalog-search-open', isMobile);
        },
        focusInput() {
          const focusOptions = { preventScroll: true };
          input.focus(focusOptions);
          window.requestAnimationFrame(() => input.focus(focusOptions));
          window.setTimeout(() => {
            if (controller.isOpen()) {
              input.focus(focusOptions);
            }
          }, 120);
        },
        open() {
          if (controller.isOpen()) {
            controller.focusInput();
            return;
          }

          document.querySelectorAll('.header__mobile[open]').forEach(closeMobileMenu);
          document.dispatchEvent(new CustomEvent(HEADER_OVERLAY_EVENT, { detail: { source: 'search' } }));
          overlay.setAttribute('aria-hidden', 'false');
          trigger.setAttribute('aria-expanded', 'true');
          controller.syncPosition();
          controller.focusInput();
        },
        close(options = {}) {
          if (!controller.isOpen()) {
            return;
          }

          overlay.setAttribute('aria-hidden', 'true');
          trigger.setAttribute('aria-expanded', 'false');
          panel.removeAttribute('aria-modal');
          document.body.classList.remove('catalog-search-open');

          if (options.restoreFocus !== false && trigger.isConnected) {
            trigger.focus({ preventScroll: true });
          }
        }
      };

      trigger.addEventListener('click', () => {
        if (controller.isOpen()) {
          controller.close();
        } else {
          controller.open();
        }
      });

      overlay.addEventListener('click', (event) => {
        if (event.target.closest('[data-header-search-close]')) {
          controller.close();
          return;
        }

        if (event.target.closest('[data-catalog-search-entry-id] a, [data-catalog-search-view-all]')) {
          controller.close({ restoreFocus: false });
        }
      });

      overlay.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          controller.close();
          return;
        }

        if (event.key !== 'Tab' || !mobileSearchMedia.matches) {
          return;
        }

        const focusable = getFocusableElements(panel);
        if (!focusable.length) {
          event.preventDefault();
          panel.focus({ preventScroll: true });
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      });

      searchControllers.add(controller);
    };

    const initializeHeader = (scope = document) => {
      const headers = [];
      const mobileMenus = [];

      if (scope.matches?.('[data-site-header]')) {
        headers.push(scope);
      }
      if (scope.matches?.('.header__mobile')) {
        mobileMenus.push(scope);
      }
      headers.push(...scope.querySelectorAll('[data-site-header]'));
      mobileMenus.push(...scope.querySelectorAll('.header__mobile'));
      headers.forEach(bindHeaderSearch);
      mobileMenus.forEach(bindMobileMenu);
    };

    initializeHeader();

    document.addEventListener('shopify:section:load', (event) => {
      updateScrolledState();
      initializeHeader(event.target);
    });

    document.addEventListener(HEADER_OVERLAY_EVENT, (event) => {
      const source = event.detail?.source;

      if (source !== 'menu') {
        document.querySelectorAll('.header__mobile[open]').forEach(closeMobileMenu);
      }

      if (source !== 'search') {
        searchControllers.forEach((controller) => {
          if (!controller.header.isConnected) {
            searchControllers.delete(controller);
            return;
          }
          controller.close({ restoreFocus: false });
        });
      }
    });

    window.addEventListener('resize', () => {
      searchControllers.forEach((controller) => {
        if (!controller.header.isConnected) {
          searchControllers.delete(controller);
          return;
        }
        controller.syncPosition();
      });
    });

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('.header__mobile-toggle');

      if (!toggle) {
        return;
      }

      const mobileMenu = toggle.closest('details');

      if (!mobileMenu?.open) {
        return;
      }

      event.preventDefault();
      closeMobileMenu(mobileMenu);
    });

    document.addEventListener('click', (event) => {
      const closeTrigger = event.target.closest('[data-mobile-menu-close]');
      const mobileLink = event.target.closest(
        '.header__mobile-link, .header__mobile-utility, .header__mobile-panel .button, .header__mobile-footer a'
      );

      if (!closeTrigger && !mobileLink) {
        return;
      }

      const mobileMenu = (closeTrigger || mobileLink).closest('details');

      closeMobileMenu(mobileMenu);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') {
        return;
      }

      document.querySelectorAll('.header__mobile[open]').forEach(closeMobileMenu);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    const initializeHero = (hero) => {
      if (!hero || instances.has(hero)) return;

      const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
      if (!slides.length) return;

      const controller = new AbortController();
      let activeIndex = 0;
      let intervalId = null;
      let pausedByEditor = false;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const heading = hero.querySelector('[data-hero-heading]');
      const text = hero.querySelector('[data-hero-text]');
      const button = hero.querySelector('[data-hero-button]');
      const buttonLabel = button?.querySelector('.button__content > span');
      const defaults = {heading:heading?.textContent,text:text?.textContent,label:buttonLabel?.textContent,url:button?.getAttribute('href')};

      const stopAutoplay = () => {
        window.clearInterval(intervalId);
        intervalId = null;
      };

      const setActiveSlide = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        const content = slides[activeIndex].dataset;
        if(heading) heading.textContent=content.heading || defaults.heading;
        if(text) text.textContent=content.text || defaults.text;
        if(buttonLabel) buttonLabel.textContent=content.buttonLabel || defaults.label;
        if(button) button.setAttribute('href', content.buttonUrl || defaults.url);
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === activeIndex);
        });
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (pausedByEditor || window.Shopify?.designMode || reduceMotion.matches || hero.dataset.autoplay !== 'true' || slides.length < 2) return;
        intervalId = window.setInterval(() => {
          setActiveSlide(activeIndex === slides.length - 1 ? 0 : activeIndex + 1);
        }, Number(hero.dataset.interval) || 4500);
      };

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          setActiveSlide(dotIndex);
          startAutoplay();
        }, { signal: controller.signal });
      });

      hero.querySelector('[data-hero-prev]')?.addEventListener('click',()=>{setActiveSlide((activeIndex-1+slides.length)%slides.length);startAutoplay()},{signal:controller.signal});
      hero.querySelector('[data-hero-next]')?.addEventListener('click',()=>{setActiveSlide((activeIndex+1)%slides.length);startAutoplay()},{signal:controller.signal});
      reduceMotion.addEventListener('change',startAutoplay,{signal:controller.signal});
      hero.addEventListener('mouseenter', stopAutoplay, { signal: controller.signal });
      hero.addEventListener('mouseleave', startAutoplay, { signal: controller.signal });
      hero.addEventListener('focusin', stopAutoplay, { signal: controller.signal });
      hero.addEventListener('focusout', (event) => {
        if (!hero.contains(event.relatedTarget)) startAutoplay();
      }, { signal: controller.signal });

      const instance = {
        selectBlock: (target) => {
          const slide = target.closest?.('[data-hero-slide]');
          const selectedIndex = slides.indexOf(slide);
          if (selectedIndex < 0) return;
          pausedByEditor = true;
          stopAutoplay();
          setActiveSlide(selectedIndex);
        },
        deselectBlock: () => {
          pausedByEditor = false;
          startAutoplay();
        },
        destroy: () => {
          stopAutoplay();
          controller.abort();
          instances.delete(hero);
        },
      };

      instances.set(hero, instance);
      setActiveSlide(0);
      startAutoplay();
    };

    const forEachHero = (scope, callback) => {
      if (scope?.matches?.('[data-hero-slider]')) callback(scope);
      scope?.querySelectorAll?.('[data-hero-slider]').forEach(callback);
    };

    const initializeHeroes = (scope = document) => forEachHero(scope, initializeHero);
    const destroyHeroes = (scope) => forEachHero(scope, (hero) => instances.get(hero)?.destroy());

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeHeroes(), { once: true });
    } else {
      initializeHeroes();
    }

    document.addEventListener('shopify:section:load', (event) => initializeHeroes(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyHeroes(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const hero = event.target.closest?.('[data-hero-slider]');
      if (hero) instances.get(hero)?.selectBlock(event.target);
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const hero = event.target.closest?.('[data-hero-slider]');
      if (hero) instances.get(hero)?.deselectBlock();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    if (window.__noxrevCartReady) {
      return;
    }

    window.__noxrevCartReady = true;

    let cartController = null;
    let cartRequestSequence = 0;

    const getCartSection = (scope = document) => scope.querySelector('[data-main-cart-section]');

    const setCartBusy = (section, isBusy) => {
      if (!section) return;
      section.classList.toggle('is-updating', isBusy);
      section.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      section.querySelectorAll('[data-cart-change], [data-cart-remove], [data-cart-checkout]').forEach((control) => {
        control.toggleAttribute('disabled', isBusy);
      });
    };

    const showCartError = (section, message) => {
      const error = section?.querySelector('[data-cart-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    };

    const clearCartError = (section) => {
      const error = section?.querySelector('[data-cart-error]');
      if (!error) return;
      error.textContent = '';
      error.hidden = true;
    };

    const updateHeaderCartCount = (itemCount) => {
      document.querySelectorAll('.header__cart-count').forEach((count) => {
        count.textContent = String(itemCount);
      });
    };

    const replaceCartSection = (html) => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextSection = parsed.querySelector('[data-main-cart-section]');
      const currentSection = getCartSection();

      if (currentSection && nextSection) {
        currentSection.replaceWith(nextSection);
      }
    };

    const changeCartLine = async ({ line, quantity }) => {
      const section = getCartSection();
      if (!section || !line) return;

      const requestId = ++cartRequestSequence;

      if (cartController) {
        cartController.abort();
      }

      cartController = new AbortController();
      clearCartError(section);
      setCartBusy(section, true);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            line: Number(line),
            quantity: Math.max(0, Number(quantity)),
            sections: [section.dataset.sectionId],
            sections_url: window.location.pathname,
          }),
          signal: cartController.signal,
        });

        const cart = await response.json();

        if (!response.ok) {
          throw new Error(cart.description || cart.message || 'Unable to update cart.');
        }

        if (requestId !== cartRequestSequence) {
          return;
        }

        const sectionHtml = cart.sections?.[section.dataset.sectionId];

        if (sectionHtml) {
          replaceCartSection(sectionHtml);
        } else {
          window.location.reload();
        }

        updateHeaderCartCount(cart.item_count || 0);
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        if (requestId === cartRequestSequence) {
          showCartError(section, error.message || 'Unable to update cart. Please try again.');
          setCartBusy(section, false);
        }
      } finally {
        if (requestId === cartRequestSequence) {
          cartController = null;
          const nextSection = getCartSection();
          setCartBusy(nextSection, false);
        }
      }
    };

    document.addEventListener('click', (event) => {
      const removeTrigger = event.target.closest('[data-cart-remove]');
      const changeTrigger = event.target.closest('[data-cart-change]');

      if (removeTrigger) {
        event.preventDefault();
        changeCartLine({ line: removeTrigger.dataset.line, quantity: 0 });
        return;
      }

      if (changeTrigger) {
        event.preventDefault();
        changeCartLine({ line: changeTrigger.dataset.line, quantity: changeTrigger.dataset.quantity });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content-blocks"]) return;
  try {
    
  (() => {
    const initAnimatedFaqs = (scope = document) => {
      scope.querySelectorAll('.product-content-blocks__faq-item').forEach((item) => {
        if (item.dataset.faqAnimated === 'true') {
          return;
        }

        const summary = item.querySelector('summary');
        const panel = item.querySelector('.product-content-blocks__faq-panel');

        if (!summary || !panel) {
          return;
        }

        if (item.open) {
          panel.style.height = 'auto';
          panel.style.opacity = '1';
        } else {
          panel.style.height = '0px';
          panel.style.opacity = '0';
        }

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (item.classList.contains('is-animating')) {
            return;
          }

          const isOpening = !item.open;
          item.classList.add('is-animating');

          if (isOpening) {
            item.open = true;
            panel.style.height = '0px';
            panel.style.opacity = '1';

            requestAnimationFrame(() => {
              panel.style.height = `${panel.scrollHeight}px`;
            });

            const onOpenEnd = (evt) => {
              if (evt.propertyName !== 'height') {
                return;
              }

              panel.style.height = 'auto';
              panel.style.opacity = '1';
              item.classList.remove('is-animating');
              panel.removeEventListener('transitionend', onOpenEnd);
            };

            panel.addEventListener('transitionend', onOpenEnd);
          } else {
            panel.style.height = `${panel.scrollHeight}px`;
            panel.style.opacity = '1';

            requestAnimationFrame(() => {
              panel.style.height = '0px';
              panel.style.opacity = '0';
            });

            const onCloseEnd = (evt) => {
              if (evt.propertyName !== 'height') {
                return;
              }

              item.open = false;
              panel.style.height = '0px';
              panel.style.opacity = '0';
              item.classList.remove('is-animating');
              panel.removeEventListener('transitionend', onCloseEnd);
            };

            panel.addEventListener('transitionend', onCloseEnd);
          }
        });

        item.dataset.faqAnimated = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAnimatedFaqs());
    } else {
      initAnimatedFaqs();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAnimatedFaqs(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest?.('.product-content-blocks__faq-item') || event.target.querySelector?.('.product-content-blocks__faq-item');
      if (!item) return;

      item.open = true;
      item.classList.remove('is-animating');
      const panel = item.querySelector('.product-content-blocks__faq-panel');
      if (panel) {
        panel.style.height = 'auto';
        panel.style.opacity = '1';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-real-life-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    document.addEventListener('shopify:block:select',event=>{
      const card=event.target.closest?.('.product-real-life-videos__card');
      if(card){card.scrollIntoView({block:'nearest',inline:'center'});card.closest('[data-real-life-videos]')?.querySelectorAll('video').forEach(v=>v.pause());}
    });

    const initializeSection = (section) => {
      if (!section || instances.has(section)) return;
      const controller = new AbortController();

      if (section.dataset.autoplay === 'true' && !window.Shopify?.designMode && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.muted=true;entry.target.play().catch(()=>{})}else entry.target.pause()}),{threshold:.6});
        section.querySelectorAll('video').forEach(v=>observer.observe(v));
        controller.signal.addEventListener('abort',()=>observer.disconnect(),{once:true});
      }
      const videoShells = section.querySelectorAll('[data-real-life-video-shell]');
      const loadPoster = (video) => {
        const posterUrl = video.dataset.posterSrc;
        if (!posterUrl) return;

        video.poster = posterUrl;
        delete video.dataset.posterSrc;
      };
      const posterObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                loadPoster(entry.target);
                observer.unobserve(entry.target);
              });
            },
            { rootMargin: '900px 500px' }
          )
        : null;

      const abortSignal = controller.signal;

      videoShells.forEach((shell) => {
        const video = shell.querySelector('video');
        const toggle = shell.querySelector('[data-real-life-video-toggle]');
        if (!video || !toggle) return;

        if (posterObserver) {
          posterObserver.observe(video);
        } else {
          loadPoster(video);
        }

        const updateState = () => {
          const isPlaying = !video.paused && !video.ended;
          toggle.classList.toggle('is-hidden', isPlaying);
          toggle.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
          toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        };

        const togglePlayback = () => {
          loadPoster(video);
          if (video.paused || video.ended) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        };

        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          togglePlayback();
        }, { signal: abortSignal });

        video.addEventListener('click', togglePlayback, { signal: abortSignal });
        video.addEventListener('play', updateState, { signal: abortSignal });
        video.addEventListener('pause', updateState, { signal: abortSignal });
        video.addEventListener('ended', updateState, { signal: abortSignal });
        updateState();
      });

      instances.set(section, {
        destroy: () => {
          posterObserver?.disconnect();
          controller.abort();
          videoShells.forEach((shell) => shell.querySelector('video')?.pause());
          instances.delete(section);
        },
      });
    };

    const forEachSection = (scope, callback) => {
      if (scope.matches?.('[data-real-life-videos]')) callback(scope);
      scope.querySelectorAll?.('[data-real-life-videos]').forEach(callback);
    };

    const initializeSections = (scope = document) => forEachSection(scope, initializeSection);
    const unloadSections = (scope) => forEachSection(scope, (section) => instances.get(section)?.destroy());

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeSections(), { once: true });
    } else {
      initializeSections();
    }
    document.addEventListener('shopify:section:load', (event) => initializeSections(event.target));
    document.addEventListener('shopify:section:unload', (event) => unloadSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-rating"] && !Shopify.designMode) return;
  try {
    
(() => {
const initialized=new WeakMap();
const init=(section)=>{
if(initialized.has(section))return;
const controller=new AbortController();
const observers=[];
const timers=[];
initialized.set(section,()=>{controller.abort();observers.forEach(o=>o.disconnect());timers.forEach(t=>clearTimeout(t));initialized.delete(section)});
    const trigger = section?.querySelector('[data-judgeme-write-review]');
    const viewReviewsTrigger = section?.querySelector('[data-judgeme-view-reviews]');
    const viewReviewsLabel = section?.querySelector('[data-judgeme-view-reviews-label]');
    const viewReviewsIcon = section?.querySelector('[data-judgeme-view-reviews-icon]');
    const ratingBars = section?.querySelector('[data-judgeme-rating-bars]');
    const widget = section?.querySelector('[data-judgeme-reviews-panel]');
    const panelBody = section?.querySelector('[data-judgeme-panel-body]');
    const viewReviewsOpenLabel = section?.dataset.closeReviewsLabel || 'Close';
    const viewReviewsClosedLabel = viewReviewsLabel?.textContent || 'View All Reviews';
    const viewReviewsClosedIcon = viewReviewsIcon?.innerHTML || '&rsaquo;';

    const renderRatingBars = () => {
      if (!ratingBars || section.dataset.showHistogram === 'false') return;

      let distribution;
      try {
        distribution = JSON.parse(ratingBars.dataset.reviewDistribution || 'null');
        if (typeof distribution === 'string') distribution = JSON.parse(distribution);
      } catch {
        return;
      }

      if (!distribution || typeof distribution !== 'object' || Array.isArray(distribution)) return;

      const counts = {};
      const distributionKeys = {
        1: 'one_star',
        2: 'two_stars',
        3: 'three_stars',
        4: 'four_stars',
        5: 'five_stars',
      };

      for (const star of [1, 2, 3, 4, 5]) {
        const key = distributionKeys[star];
        if (!Object.prototype.hasOwnProperty.call(distribution, key)) return;

        const rawCount = distribution[key];
        if (rawCount === null || rawCount === '' || typeof rawCount === 'object') return;

        const count = Number(rawCount);
        if (!Number.isSafeInteger(count) || count < 0) return;
        counts[star] = count;
      }

      const total = Object.values(counts).reduce((sum, count) => sum + count, 0);
      const reviewCount = Number(ratingBars.dataset.reviewCount);
      if (total <= 0 || total !== reviewCount) return;

      ratingBars.querySelectorAll('[data-rating-row]').forEach((row) => {
        const count = counts[row.dataset.ratingRow];
        const percent = (count / total) * 100;
        row.querySelector('[data-rating-count]').textContent = count.toLocaleString();
        row.querySelector('[data-rating-bar]').style.width = `${percent}%`;
      });

      ratingBars.hidden = false;
    };

    const adoptExternalJudgeMeWidget = () => {
      if (!panelBody) return false;

      const externalWidget = Array.from(document.querySelectorAll('.jdgm-widget.jdgm-review-widget, .jdgm-review-widget')).find((node) => {
        return node instanceof HTMLElement && !section.contains(node) && node.querySelector('.jdgm-rev-widg, .jdgm-rev, .jdgm-widget-actions-wrapper, .jdgm-histogram');
      });

      if (!externalWidget) return false;

      const existingPanelWidget = panelBody.querySelector('.jdgm-widget.jdgm-review-widget, .jdgm-review-widget');
      const originalWrapper = externalWidget.closest('.shopify-section, .shopify-app-block, section, [id^="shopify-section"]');

      if (existingPanelWidget && existingPanelWidget !== externalWidget) {
        existingPanelWidget.remove();
      }

      panelBody.appendChild(externalWidget);

      if (originalWrapper instanceof HTMLElement && !section.contains(originalWrapper)) {
        originalWrapper.style.display = 'none';
      }

      return true;
    };

    const watchExternalJudgeMeWidget = () => {
      if (adoptExternalJudgeMeWidget()) return;

      const observer = new MutationObserver(() => {
        if (adoptExternalJudgeMeWidget()) observer.disconnect();
      });

      observers.push(observer);
      observer.observe(document.body, { childList: true, subtree: true });
      timers.push(window.setTimeout(() => observer.disconnect(), 10000));
    };

    watchExternalJudgeMeWidget();
    renderRatingBars();

    const showReviews = () => {
      if (!widget) return;

      widget.classList.add('is-open');
      widget.setAttribute('aria-hidden', 'false');
      viewReviewsTrigger?.setAttribute('aria-expanded', 'true');
      if (viewReviewsLabel) viewReviewsLabel.textContent = viewReviewsOpenLabel;
      if (viewReviewsIcon) viewReviewsIcon.textContent = '';
      window.requestAnimationFrame(() => {
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    };

    const hideReviews = () => {
      if (!widget) return;

      widget.classList.remove('is-open');
      widget.setAttribute('aria-hidden', 'true');
      viewReviewsTrigger?.setAttribute('aria-expanded', 'false');
      if (viewReviewsLabel) viewReviewsLabel.textContent = viewReviewsClosedLabel;
      if (viewReviewsIcon) viewReviewsIcon.innerHTML = viewReviewsClosedIcon;
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    viewReviewsTrigger?.addEventListener('click', (event) => {
      event.preventDefault();

      if (widget?.classList.contains('is-open')) {
        hideReviews();
        return;
      }

      showReviews();
    }, {signal:controller.signal});

    if (!trigger) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      showReviews();
      window.setTimeout(() => {
        section
          .querySelector('.jm-button--primary, .jdgm-write-rev-link, .jdgm-write-rev-link a, .jdgm-write-rev-link button, [data-judgeme-open-review-form]')
          ?.click();
      }, 450);
    }, {signal:controller.signal});

};
const each=(root,fn)=>{if(root.matches?.('[data-review-section]'))fn(root);root.querySelectorAll?.('[data-review-section]').forEach(fn)};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>each(document,init),{once:true});else each(document,init);
document.addEventListener('shopify:section:load',e=>each(e.target,init));
document.addEventListener('shopify:section:unload',e=>each(e.target,s=>initialized.get(s)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-search-section]');

    if (!root) {
      return;
    }

    const sectionId = root.dataset.sectionId;
    let abortController = null;
    let requestId = 0;
    let debounceTimer = null;

    const getParts = () => ({
      form: root.querySelector('[data-search-form]'),
      input: root.querySelector('[data-search-input]'),
      status: root.querySelector('[data-search-status]'),
      results: root.querySelector('[data-search-results]'),
      error: root.querySelector('[data-search-error]')
    });

    const setError = (message) => {
      const { error } = getParts();

      if (!error) {
        return;
      }

      error.textContent = message;
      error.hidden = false;
    };

    const clearError = () => {
      const { error } = getParts();

      if (error) {
        error.hidden = true;
      }
    };

    const buildUrl = (query, sourceUrl = root.querySelector('[data-search-form]').action) => {
      const url = new URL(sourceUrl, window.location.origin);
      const normalizedQuery = query.trim();

      if (normalizedQuery) {
        url.searchParams.set('q', normalizedQuery);
      } else {
        url.searchParams.delete('q');
      }

      url.searchParams.set('section_id', sectionId);
      return url;
    };

    const replaceSearchContent = (html) => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextRoot = parsed.querySelector('[data-search-section]');
      const nextStatus = nextRoot ? nextRoot.querySelector('[data-search-status]') : null;
      const nextResults = nextRoot ? nextRoot.querySelector('[data-search-results]') : null;
      const { status, results } = getParts();

      if (!nextRoot || !nextStatus || !nextResults || !status || !results) {
        throw new Error('Search section response was incomplete.');
      }

      status.replaceWith(nextStatus);
      results.replaceWith(nextResults);
    };

    const updateUrl = (query, mode) => {
      const url = new URL(window.location.href);
      const normalizedQuery = query.trim();

      if (normalizedQuery) {
        url.searchParams.set('q', normalizedQuery);
      } else {
        url.searchParams.delete('q');
      }

      if (mode === 'push') {
        history.pushState({}, '', url.toString());
      } else {
        history.replaceState({}, '', url.toString());
      }
    };

    const runSearch = async (query, mode = 'replace', sourceUrl) => {
      const currentRequestId = ++requestId;

      if (abortController) {
        abortController.abort();
      }

      abortController = new AbortController();
      clearError();
      root.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(buildUrl(query, sourceUrl).toString(), {
          signal: abortController.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) {
          throw new Error('Search request failed.');
        }

        const html = await response.text();

        if (currentRequestId !== requestId) {
          return;
        }

        replaceSearchContent(html);
        updateUrl(query, mode);
      } catch (error) {
        if (error.name === 'AbortError' || currentRequestId !== requestId) {
          return;
        }

        setError('Search could not update. Please try again.');
      } finally {
        if (currentRequestId === requestId) {
          root.setAttribute('aria-busy', 'false');
        }
      }
    };

    root.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-search-form]');

      if (!form) {
        return;
      }

      event.preventDefault();
      clearTimeout(debounceTimer);
      runSearch(new FormData(form).get('q') || '', 'push');
    });

    root.addEventListener('input', (event) => {
      const input = event.target.closest('[data-search-input]');

      if (!input) {
        return;
      }

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => runSearch(input.value, 'replace'), 300);
    });

    root.addEventListener('click', (event) => {
      const link = event.target.closest('.search__pagination a');

      if (!link) {
        return;
      }

      event.preventDefault();
      const url = new URL(link.href, window.location.origin);
      runSearch(url.searchParams.get('q') || '', 'push', url.toString());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
